import { PortfolioUpload } from "./PortfolioUpload";

export default {
    create: PortfolioUpload
};

